import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import XplorerImageEditor from '@blade-sxp/monitor/components/image-editor/image-editor.vue';
import RTSPDialog from './fragments/rtsp-dialog.vue';
import { ImageEditorModule } from '@blade-sxp/monitor/store/image-editor';
import { handleError } from '@blade/common/utils/handle-error';
import { QueueModule } from '@blade-sxp/monitor/store/queue';
import { drawPolygon, drawDirArrow, drawLine } from '@blade-sxp/monitor/components/rtsp-player/libs/utils';
import { imageLoad } from '@blade-sxp/monitor/pages/main/monitoring/components/ControlManagement/config/imageload';
import { getPerpVertex } from '@blade-sxp/monitor/utils/rzcanvas/util';
let default_1 = class extends Vue {
    imgSrc = '';
    showDrawer = false;
    stateMap = {
        none: 0,
        circle: 1,
        screenShot: 2,
        drawRects: 3,
    };
    drawState = this.stateMap.circle;
    options = {
        radius: 15,
        drawCircleOption: {
            dashed: false,
        },
        lineColor: ['#FA6400', 'rgba(250, 100, 0, 0.54)'],
        // weight: Math.floor(15/2)
    };
    config = {
        circleLength: 100,
    };
    value = '';
    outerCircles = [
        {
            vertex: { x: 0.2089552238806, y: 0.79104477611943 },
            options: { radius: 20 },
            meta: { deviceId: ['5', '10'], deviceName: '5', taskId: '70' },
        },
        {
            vertex: { x: 896.8656716417911, y: 350.5970149253732 },
            options: { radius: 15 },
            meta: { deviceId: '5', deviceName: '5', taskId: '70' },
        },
        {
            vertex: { x: 965.3731343283582, y: 369.4029850746269 },
            options: { radius: 30 },
            meta: { deviceId: '5', deviceName: '5', taskId: '70' },
        },
    ];
    numberOfLimit = 100;
    target;
    outerVisible = false;
    editorMode = 'VIEW';
    ws;
    currDevice = {};
    currVal = '0';
    videoUrl = '';
    timeUrl;
    image_size = 10 * 1024 * 1024;
    handleInputChange(val) {
        console.log('val:', val.target.value);
        // this.currVal=(val.target as any).value;
    }
    mounted() {
        // const res = window.localStorage.getItem('circles');
        // const circles = JSON.parse(res!);
        // this.outerCircles= circles;
        this.calibrateContainer();
        this.getImage();
        this.getCircles();
        // this.debugCanvas();
    }
    debugCanvas() {
        const canvasEle = this.$refs.canvas;
        canvasEle.width = 1184;
        canvasEle.height = 1200;
        canvasEle.zIndex = 100;
        const vertices = [
            { x: 1021, y: 16 },
            { x: 605, y: 364 },
            { x: 1083, y: 711 },
            { x: 2000, y: 145 },
            { x: 1021, y: 16 },
        ];
        const ctx = canvasEle.getContext('2d');
        const start = { x: 1050, y: 517 };
        const end = { x: 363, y: 568 };
        drawPolygon(ctx, vertices, { lineColor: '#fff', fillColor: '#fff', weight: 2, scale: 0.5 });
        drawLine(ctx, start.x, start.y, end.x, end.y, 1);
        drawDirArrow(ctx, { start, end }, 15);
        const perpCoordinate = getPerpVertex({ x: 1050, y: 517 }, { x: 363, y: 568 }, 10);
        drawLine(ctx, perpCoordinate.x, perpCoordinate.y, perpCoordinate.x + 20, perpCoordinate.y, 1);
        console.log('angle:', perpCoordinate.y);
        const divChild = document.createElement('div');
        const parentNode = this.$refs.canvas.parentElement;
        if (!parentNode) {
            return;
        }
        console.log('parent:', parentNode);
        parentNode.appendChild(divChild);
        console.log('div child:', parentNode);
        divChild.className = 'crowd-dir';
        divChild.style.left = `${perpCoordinate.x}px`;
        divChild.style.top = `${perpCoordinate.y}px`;
        divChild.style.transform = `rotate(${perpCoordinate.rotate}deg)`;
        divChild.style['transform-origin'] = 'left center';
    }
    async getImage() {
        try {
            const res = await ImageEditorModule.getImage();
            this.calibrateContainer();
            this.imgSrc = res;
            return res;
        }
        catch (e) { }
    }
    async getCircles() {
        try {
            const res = await QueueModule.getHeat();
            // const vertices = res.list.filter(item => item.vertices && item.heatValue !== 0);
            const mapCircles = this.mapCircles(res?.taskDeviceInfoVOS);
            console.log('circles:', mapCircles);
            // this.outerCircles = mapCircles.length === 0 ? this.outerCircles : mapCircles;
            this.outerCircles = mapCircles;
        }
        catch (e) {
            console.log('e:', e);
        }
    }
    mapCircles(vertices) {
        const res = vertices.map(item => {
            const { heatValue, vertices, ...rest } = item;
            const heatRadius = this.getRadius(heatValue);
            return { vertex: vertices, options: { radius: heatRadius, lineColor: this.options.lineColor }, meta: rest };
        });
        return res;
    }
    getRadius(radius) {
        const res = radius / 2 <= 15 ? 15 : radius / 2 >= 100 ? 100 : radius / 2;
        return res;
    }
    handleDrawCircles(circles) {
        this.outerCircles = [...circles];
        // window.localStorage.setItem('circles', JSON.stringify(this.outerCircles))
    }
    handleDrawCircleDone() {
        this.$elmessage(`${this.$t('reachMax')} ${this.config.circleLength}`);
    }
    handleImage() {
        console.log('image');
    }
    async handleFileChange(e) {
        this.target = e.target;
        const file = e.target.files[0];
        const img = await this.convertBase64(file);
        const imageOri = await imageLoad(img);
        if (imageOri.width > 5000 || imageOri.height > 5000 || img.size > this.image_size || !this.getType(file.type)) {
            this.$elmessage(this.$t('imgMap'));
            this.target.value = '';
            return;
        }
        const res = await this.updateImage(img);
        console.log('res:', file);
        this.target.value = '';
        if (res) {
            this.imgSrc = img;
        }
    }
    getType(item) {
        const types = ['image/jpeg', 'image/png', 'image/bmp'];
        if (types.includes(item)) {
            return true;
        }
        return false;
    }
    calibrateContainer() {
        const domEle = document.querySelector('.queue-dashboard-container');
        const minWidth = window.innerWidth * 0.8 > 1184 ? window.innerWidth * 0.8 : 1184;
        domEle.style.minWidth = `${minWidth}px`;
        domEle.style.maxWidth = `${minWidth}px`;
        domEle.style.height = `${(minWidth * 9) / 16}px`;
    }
    convertBase64(file) {
        return new Promise(resolve => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = () => resolve(false);
        });
    }
    async updateImage(data) {
        try {
            await ImageEditorModule.updateImage(data);
            return true;
        }
        catch (e) {
            handleError(e);
            return false;
        }
    }
    async getRtsp(data) {
        try {
            const res = await QueueModule.getRtsp({ deviceId: data.deviceId, taskId: data.taskId });
            console.log('url:', res);
            this.videoUrl = res.rtspPreviewAddress;
            return true;
        }
        catch (e) {
            handleError(e);
            return false;
        }
    }
    async handleOpen(circle) {
        clearTimeout(this.timeUrl);
        console.log('open:', circle);
        this.currDevice = { deviceId: circle.meta.deviceIds, taskId: circle.meta.taskId };
        QueueModule.updateTaskId(this.currDevice.taskId);
        // const res = await this.getRtsp({ deviceId: circle.meta.deviceId, taskId: circle.meta.taskId });
        this.outerVisible = true;
    }
    handleClose() {
        console.log('close');
        this.outerVisible = false;
    }
    handleEdit(circle) {
        const id = circle.meta.taskId;
        if (!id) {
            return;
        }
        this.$router.push(`/queue/taskManagement/editQueueControl/${id}`);
    }
    handleCreate() {
        this.$router.push('/queue/taskManagement/createQueueControl');
    }
    async handleDelete(circle) {
        try {
            await QueueModule.deleteTask(circle.meta.taskId || 0);
            this.getCircles();
        }
        catch (e) {
            handleError(e);
        }
    }
    handleCircles(circle) {
        const { heatValue, taskDetail, taskId } = circle;
        this.outerCircles = this.outerCircles
            .map((item) => {
            if (item.meta.taskId.toString() === taskId.toString()) {
                const { vertex, options, meta } = item;
                const { taskDetail: task, ...rest } = meta;
                options.radius = this.getRadius(heatValue);
                const res = { vertex, options, meta: { taskDetail, ...rest } };
                return res;
            }
            return item;
        })
            .slice();
    }
};
default_1 = __decorate([
    Component({
        name: 'ImageDashboard',
        components: {
            'xplorer-image': XplorerImageEditor,
            'rtsp-dialog': RTSPDialog,
        },
        i18n: {
            messages: {
                'en-us': {
                    mapRato: 'Map Rate',
                    changeMap: 'Change Map',
                    createMap: 'Create Map',
                    imgMap: 'The image needs to be less than 5K * 5K with size less than 10 MB and formats are jpg, png, bmp',
                    reachMax: 'You have reached the maximum number of circles',
                },
                zh: {
                    mapRato: '底图比例',
                    changeMap: '更换底图',
                    createMap: '新增底图',
                    imgMap: '图片尺寸小于5k * 5k体积小于10 MB, 图片格式为jpg, png, bmp',
                    reachMax: '已达到最大可允许标点数量',
                },
            },
        },
    })
], default_1);
export default default_1;
